// SettingCard.jsx
import React from 'react';
import './SettingCard.css';

const SettingCard = ({ 
  icon, 
  title, 
  description, 
  onClick, 
  enabled = true,
  variant = 'default',
  comingSoon = false,
  comingSoonText = 'Próximamente'
}) => {
  const isInteractive = enabled && !comingSoon;

  const handleClick = () => {
    if (isInteractive && onClick) {
      onClick();
    }
  };

  const handleKeyPress = (e) => {
    if ((e.key === 'Enter' || e.key === ' ') && isInteractive && onClick) {
      e.preventDefault();
      onClick();
    }
  };

  return (  
    <div 
      className={`setting-card ${variant} ${!enabled ? 'disabled' : ''} ${comingSoon ? 'coming-soon' : ''}`}
      onClick={handleClick}
      onKeyPress={handleKeyPress}
      tabIndex={isInteractive ? 0 : -1}
      role="button"
      aria-label={`${title}: ${description}${comingSoon ? ` (${comingSoonText})` : ''}`}
    >
      <div className="setting-card-icon">
        {typeof icon === 'string' ? (
          <i className={icon}></i>
        ) : (
          icon
        )}
      </div>
      
      <div className="setting-card-content">
        <div className="setting-card-title-wrapper">
          <h3 className="setting-card-title">{title}</h3>
          {comingSoon && (
            <span className="setting-card-badge">{comingSoonText}</span>
          )}
        </div>
        <p className="setting-card-description">{description}</p>
      </div>
      
      <div className="setting-card-arrow">
        {comingSoon ? (
          // Icono de reloj para "próximamente"
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5"/>
            <polyline points="12,6 12,12 16,14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        ) : (
          // Flecha normal
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path 
              d="M7.5 15L12.5 10L7.5 5" 
              stroke="currentColor" 
              strokeWidth="1.5" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
          </svg>
        )}
      </div>
    </div>
  );
};

export default SettingCard;